module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/1-511fe607dd3ae6e71ab0596de7095776.jpg";